import { toBase64 } from './file-converter'
const mimeTypes = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  video: 'video/mp4'
}
export const UploadFile = async function (
  file = {},
  param = { filename: '', extension: '', isBase64: false, base64: '' },
  isPrivate
) {
  const functionName = isPrivate
    ? 'helpers/upload_private_file'
    : 'helpers/upload_file'
  const { isBase64 = false, base64 = '', extension } = param
  if (!this[functionName]) {
    throw new Error('No se encontró la función helpers/upload_file')
  }
  const isFile = file instanceof File
  if (!isFile && !isBase64) throw new Error('Archivo no válido.')

  let fileName = param.filename || file.name
  fileName = fileName.includes('.') ? fileName.split('.').shift() : fileName
  fileName = fileName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  fileName = fileName.replace(/[^a-zA-Z0-9_\-\s]/gi, '').trim()
  fileName = fileName.replace(/\s/g, '_')
  const params = {
    mime: file.type || mimeTypes[extension]
  }
  const { name = '' } = file
  if (name.includes('.') || isBase64) {
    params.file_extension = extension || file.name.split('.').pop()
    params.file_name = fileName
  }
  const fileBase64 = await (isBase64 ? base64 : toBase64(file, true))
  params.file = fileBase64
  return new Promise((resolve, reject) => {
    this[functionName]({
      ...params,
      callback: (res) => {
        if (res.error) return reject(new Error(res.error))
        if (param !== 'name') return resolve(res.resource.url)
        const name = res.resource.url.split('/').pop()
        return resolve(name)
      }
    })
  })
}
